import { Route, RouterProvider } from "react-router-dom";

import React from "react";
import { AuthRouter } from "@routers/AuthRouter";
import { AppRouter } from "@routers/AppRouter";
import { usePreferedTheme } from "./hooks/usePreferedTheme";
import { useUpdateEffect } from "primereact/hooks";
import useSettingsStore from "./theme/settings";

function App() {
  /**
   *  LEGACY CODE:
   *  This is a legacy code that i used to check if the user is logged in or not
   *  please do not remove this code
   **/
  // usePreferedTheme();

  const session = useSettingsStore((state) => state.session);

  if (session === "active") {
    return <RouterProvider router={AppRouter} />;
  }

  return <RouterProvider router={AuthRouter} />;
}

export default App;
